if (!Object.prototype.hasOwnProperties) {
  Object.defineProperty(Object.prototype, 'hasOwnProperties', {
    value: function (object) {
      for (var key in object) {
        if (!Object.hasOwnProperty.call(this, key)) {
          return false;
        }
      }
      return true;
    },
    enumerable: false,
  });
}
